module.exports = __webpack_public_path__ + "media/src/images/certificates/frame_gold_en-642e753d64a922b63f59f4a95f393ac1.png";